var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{class:_vm.alertClass,attrs:{"border":_vm.border,"colored-border":"","color":_vm.color}},[_c('v-card',{class:_vm.cardClass,attrs:{"color":"card"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }